import { Grid } from "@mui/material";
import { Theme } from "../../../Style/Theme";
import { Text5 } from "../../atoms/Typography/Text/Text";

// this funcationality will provide the patient caller request
export const Message = ({ name }) => {
  return (
    <>
      <Grid container direction={"column"} mb={4}>
        <Grid item>
          <Text5 text={name} color={Theme.palette.background.grayDark} />
        </Grid>
      </Grid>
    </>
  );
};
